import React, { useEffect, useState } from "react";
import SectionHeader from "../../components/commons/SectionHeader";
import QurealSection from "../../common/QurealSection";
import { Button, Form, Image, Input, Table, Upload, message } from "antd";
import { PlusOutlined, UserAddOutlined } from "@ant-design/icons";
import { BASE_URL } from "../../constants";
import { restoreAccessToken } from "../../_helpers/auth";
import { useUploadFile } from "../../actions/files";
import { getPublicImageURL } from "../../_helpers/image";
import { useGenerateModelFromImages } from "../../_actions/bot";
import { getHeroIcon } from "../../_helpers/heroicons";
import log, { d } from "cslog";
import { useItemsFine } from "../../_actions/app/items";
import { useCreateItem } from "../../_actions/mutations/items";
import { useAIModel } from "../../_actions/bot";
import ImageGenerator from "./ImageGenerator";

function AIModelManager({ me }) {
    const muationGen = useGenerateModelFromImages(
        (data) => {},
        () => {}
    );
    const [data, setData] = useState({
        images: [],
    });
    const [id, setId] = useState();
    const createMutation = useCreateItem("qdb_ai_model", (data) => {
        console.log("item created successfully", data);
    });

    const onSubmit = (values) => {
        log.d(values, "values");
        const payload = {
            name: values.name,
            reference_images: {
                create:
                    data.reference_images ||
                    data.directus_files_id?.images?.map((item) => ({
                        directus_ai_model_id: "+",
                        directus_files_id: { id: item.id },
                    })) ||
                    [],
            },
        };
        console.log("paylaod", payload);
        createMutation.mutate(payload, {
            onSuccess: (responseData) => {
                message.success("Model created successfully!");
                setId(responseData.id);
                muationGen.mutate({ id: responseData.id });
            },
            onError: (error) => {
                console.error("Failed to create Model:", error);
                message.error("Failed to create Model");
            },
        });

        console.log(createMutation, "data created");
    };

    return (
        <>
            <QurealSection
                header={
                    <SectionHeader
                        heading="Make Me A Model"
                        icon={<UserAddOutlined />}
                    >
                        {/* <Button type="primary" >Generate Model</Button> */}
                    </SectionHeader>
                }
                footer={false}
            >
                <div style={{ padding: "20px" }}>
                    <Form layout="vertical" onFinish={onSubmit}>
                        <Form.Item label="Model Name" name="name">
                            <Input
                                value={data.name}
                                onChange={(e) =>
                                    setData({ ...data, name: e.target.value })
                                }
                            />
                        </Form.Item>
                        <Form.Item
                            label="Person photos for training (minimum 3)"
                            name="reference_images"
                        >
                            <ImageArrayUpload
                                value={data.images}
                                onChange={(val) => {
                                    setData({
                                        ...data,
                                        images: val,
                                        reference_images: val.map((item) => ({
                                            directus_ai_model_id: "+",
                                            directus_files_id: { id: item.id },
                                        })),
                                    });
                                }}
                            />
                        </Form.Item>
                        <Button
                            type="primary"
                            htmlType="submit"
                            // disabled={
                            //     (data.directus_files_id?.images || []).length <
                            //     3
                            // } // Check the nested property
                            icon={getHeroIcon("sparkles", {
                                width: "15px",
                                color: "white",
                            })}
                        >
                            Generate
                        </Button>
                    </Form>
                </div>
                <ImageGenerator />
            </QurealSection>
            <ModelTable />
        </>
    );
}

export default AIModelManager;

const getBase64 = (file) =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
    });

export function ImageArrayUpload({ value = [], onChange }) {
    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState("");
    const [fileList, setFileList] = useState(value);
    const mutationUpload = useUploadFile((data) => {
        setFileList([
            ...fileList.filter((item) => item.uid !== "temp"),
            {
                uid: data?.id,
                name: data?.filename_download,
                status: "done",
                url: getPublicImageURL(data?.id),
            },
        ]);
    });

    useEffect(() => {
        onChange(
            fileList
                .filter((item) => item.uid !== "temp")
                .map((item) => ({ id: item.uid }))
        );
    }, fileList);

    const handlePreview = async (file) => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj);
        }
        setPreviewImage(file.url || file.preview);
        setPreviewOpen(true);
    };

    const handleUpload = ({ fileList }) => {
        const uploaded_image = fileList[fileList.length - 1]?.originFileObj;
        if (uploaded_image) {
            if (typeof uploaded_image === "object" && uploaded_image !== null) {
                const formData = new FormData();
                formData.append("file", uploaded_image);
                mutationUpload.mutate(formData);
            }
        }

        setFileList((old_list) => [
            ...old_list,
            {
                uid: "temp",
                name: "image.png",
                status: "uploading",
                url: "abcd",
            },
        ]);
    };

    const uploadButton = (
        <button style={{ border: 0, background: "none" }} type="button">
            <PlusOutlined />
            <div style={{ marginTop: 8 }}>Upload</div>
        </button>
    );

    return (
        <>
            <Upload
                // action="https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload"
                action={`${BASE_URL}files`}
                method="post"
                headers={{ Authorization: "Bearer " + restoreAccessToken() }}
                listType="picture-card"
                fileList={fileList}
                onPreview={handlePreview}
                onChange={handleUpload}
                beforeUpload={() => false}
            >
                {fileList.length >= 8 ? null : uploadButton}
            </Upload>
            {previewImage && (
                <Image
                    wrapperStyle={{ display: "none" }}
                    preview={{
                        visible: previewOpen,
                        onVisibleChange: (visible) => setPreviewOpen(visible),
                        afterOpenChange: (visible) =>
                            !visible && setPreviewImage(""),
                    }}
                    src={previewImage}
                />
            )}
        </>
    );
}

function ModelTable() {
    const { isLoading, isSuccess, data } = useItemsFine(
        "qdb_ai_model",
        "fields=*,poses.photo,poses.qdb_ai_pose_id.name",
        true
    );
    const [rows, setRows] = useState([]);
    const [columns, setColumns] = useState([]);

    useEffect(() => {
        if (isSuccess) {
            const out = [];
            const out_cols = ["name"];
            data.forEach((item) => {
                const row = {
                    key: item.id,
                    name: item.name,
                    feature_image: item.feature_image,
                };
                item.poses.forEach((post) => {
                    row[post.qdb_ai_pose_id.name] = post.photo;
                    if (!out_cols.includes(post.qdb_ai_pose_id.name)) {
                        out_cols.push(post.qdb_ai_pose_id.name);
                    }
                });
                out.push(row);
            });
            setRows(out);
            setColumns(
                out_cols.map((col) => ({
                    title: col,
                    dataIndex: col,
                    key: col,
                    render: (text, item) =>
                        col === "name" ? (
                            item[col]
                        ) : (
                            <Image
                                src={getPublicImageURL(item[col])}
                                width={50}
                            />
                        ),
                }))
            );
        }
    }, [isSuccess, data]);

    return (
        <QurealSection
            header={
                <SectionHeader
                    heading="All Models"
                    icon={<UserAddOutlined />}
                ></SectionHeader>
            }
        >
            <div style={{ padding: "20px" }}>
                {isSuccess && (
                    <Table columns={columns} dataSource={rows} bordered />
                )}
            </div>
        </QurealSection>
    );
}
